import { AppShell, type NavItem } from '@/components/shared/app-shell'
import { Icon } from '@/components/icons/icon'

// Platform console (app.ringout.ai/admin) — reads across every account, so it is for platform_* roles only
// (ADR-039). No MFA yet, by decision (ADR-046). The API is the guard; this page tree is not one.
const NAV: NavItem[] = [
  { to: '/admin', label: 'Overview', icon: 'chart', end: true },
  { to: '/admin/accounts', label: 'Accounts', icon: 'home' },
  { to: '/admin/calls', label: 'Calls', icon: 'phone' },
  { to: '/admin/leads', label: 'Leads', icon: 'mail' },
  { to: '/admin/billing', label: 'Billing', icon: 'card' },
  { to: '/admin/queue', label: 'Queue', icon: 'gear' },
]

export function AdminLayout() {
  return (
    <AppShell
      area="Platform console"
      nav={NAV}
      // Reads across every account, so it says so on every page.
      marker={
        <span
          title="RingOut team only"
          className="inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 py-1.5 text-caption font-medium text-muted-foreground sm:px-3"
        >
          <Icon name="check" className="size-3.5 text-link" />
          <span className="sr-only sm:not-sr-only">RingOut team only</span>
        </span>
      }
    />
  )
}
